module.exports = __webpack_public_path__ + "img/4-linguagem.472cc990.png";